// =============================================================================
//  Copyright : 2024 semantics GmbH
//  Date      : $Date: 2024-11-29 17:06:17 +0100 (Fri, 29 Nov 2024) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 147884 $
//  Purpose   : domain icon
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import log from 'uix/logging'
import {Actions, Sel} from 'uix/registries'
import {useSelector} from 'uix/hooks'
import {VIcon} from 'graphics'

// ---Globals

export const DomainIcon = ({dname, odid}) => {
  let domains = useSelector(Sel.domains)
  dname = dname || domains.odid2name[odid]
  let ddata = domains.data[dname] ?? {}
  let iconfig = useSelector(Sel.iconfig)
  let colorizeDomains = useSelector(root => root.ui.byId['Global/colorizeDomains']?.value)
  let color = colorizeDomains ? ddata.color : undefined
  return <VIcon name={`domain_${iconfig.itypes.byId[10][ddata.type]}`} style={{color}} />
  //~ return <VIcon name="warehouse" style={{color}} />
}
